import React from 'react';
import SelectedProduct from './SelectedProduct'
import DOMPurify from 'dompurify';
import Img from '../Img';
import { useQuantityProductInCartConference, vibrate, cropString, isAllergen } from '../../../Utils/Helpers';
import ProductPrice from './ProductPrice';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { useStoreHook } from '../../../Hooks/StoreHook';
import BadgeAllergenTag from './BadgeAllergenTag';
import BadgeProductTagFlag from './BadgeProductTagFlag';
import { useNavigate } from 'react-router-dom';

interface CardProductProps {
    product: any;
    category: any;
    loading?: boolean;
}

const CardProduct = ({
    product,
    category,
    loading,
}: CardProductProps) => {

    const { getLinkToHome, openProductToAdd } = useStoreHook();
    const { isMobile, setEnableLoadProducts } = useLayoutContext();
    const navigate = useNavigate();

    const handleProduct = async () => {

        const opened = await openProductToAdd(product, category);
        if (!opened) return; //* Produto bloqueado (ex: composto sem rodízio no carrinho)

        setEnableLoadProducts(false);
        navigate(`${getLinkToHome()}/produto/${product.slug || product.id}`, { replace: true });
        vibrate();

    }

    const description = DOMPurify.sanitize(product.description);
    const quantitySelected = useQuantityProductInCartConference(product.id);

    return (
        <>
            {!loading
                ?
                    <div onClick={handleProduct} className="relative p-3 md:p-4 shadow rounded-xl md:rounded-xl overflow-hidden cursor-pointer transition ease-in-out
                        ring-1 ring-gray-100
                        md:active:shadow-lg
                        md:active:ring-4
                        md:active:ring-custom-primary
                        md:active:text-custom-primary
                        hover:text-shopfood-title
                        md:hover:shadow-md
                        md:hover:shadow-gray-100
                        ">
                        <div className={`relative flex gap-3 w-full h-full ${!product.photos?.medium ? 'pr-3' : ''}`}>
                            <div className={`flex flex-grow flex-col justify-between gap-2 ${isAllergen(product) ? 'opacity-50' : ''}`}>
                                <h3 className="font-bold">{ cropString(product.name, 40) }</h3>
                                <div className='h-full text-sm leading-4 text-gray-500'>
                                    {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                    <BadgeNewProduct product={product} className='inline-block mr-1 rounded' />
                                    <span dangerouslySetInnerHTML={{ __html: cropString(description, 80) }} />
                                </div>
                                <h4 className="flex items-center text-sm font-medium mt-1 text-gray-500">
                                    <ProductPrice product={product} breakLine={isMobile} />

                                    {/* PRODUCT SALE  */}
                                    <BadgeProductSale product={product} className='inline-block ml-2 rounded' />
                                </h4>
                            </div>
                            {product.photos?.medium ?
                                <div className="relative flex items-center justify-end">

                                    {/* ALLERGEN TAG  */}
                                    <BadgeAllergenTag product={product} className='absolute top-0 w-full aspect-square z-10' />

                                    <div className={`relative self-start w-24 lg:w-28 aspect-square transition-width ease-in-out ${isAllergen(product) ? 'opacity-50' : ''}`}>
                                        {/* PRODUCT IN CART */}
                                        {(quantitySelected > 0) && <SelectedProduct quantity={quantitySelected} className="rounded-lg" />}
                                        <Img src={product.photos.medium} alt={product.name} className="w-full h-full rounded-lg object-cover transition-width ease-in-out duration-200" />
                                    </div>
                                </div>
                            :
                                (quantitySelected > 0) && <SelectedProduct quantity={quantitySelected} className="rounded-lg" />
                            }

                            {/* PRODUCT TAG FLAG  */}
                            <div className='absolute top-1 right-1 flex justify-end'><BadgeProductTagFlag product={product} /></div>
                        </div>
                    </div>
                :
                <div className="flex gap-4 w-full p-4 rounded-xl md:rounded-xl ring-1 ring-gray-100 animate-pulse">
                    <div className="flex flex-col gap-4 justify-between flex-grow">
                        <div className="bg-gray-200 h-10 rounded-lg"></div>
                        <div className="flex flex-col gap-1.5 w-full h-full">
                        <div className="bg-gray-200 w-full h-2 rounded"></div>
                        <div className="bg-gray-200 w-full h-2 rounded"></div>
                        <div className="bg-gray-200 w-[85%] h-2 rounded"></div>
                        <div className="bg-gray-200 w-[70%] h-2 rounded"></div>
                    </div>
                        <div className="flex gap-2 mt-2 items-center">
                            <div className="bg-gray-200 h-4 rounded-lg flex-grow"></div>
                            <div className="bg-gray-200 h-4 w-16 rounded-lg"></div>
                        </div>
                    </div>
                    <div className="flex items-center justify-end">
                        <div className="self-start flex bg-gray-200 min-w-20 min-h-20 md:min-w-24 md:min-h-24 lg:min-w-28 lg:min-h-28 rounded"></div>
                    </div>
                </div>
            }
        </>
    );
};

export default CardProduct;
